import { render, staticRenderFns } from "./WebhookCreate.vue?vue&type=template&id=ae467f22&"
import script from "./WebhookCreate.vue?vue&type=script&lang=ts&"
export * from "./WebhookCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports